<template>
  <div></div>
</template>

<script>
import dayjs from 'dayjs'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
import 'dayjs/locale/fr' // load on demand

dayjs.extend(LocalizedFormat)
dayjs.locale('fr') // use French locale globally

export default {
  name: 'Widget',
  computed: {
    caller: {
      get () {
        return this.$store.getters.caller
      },
      set (value) {
        return this.$store.commit('updateCaller', value)
      }
    }
  },
  methods: {
    _handleAbc (tree, ref, $event) {
      const newNode = document.createElement('div')
      newNode.setAttribute('class', 'wrapper')
      newNode.innerHTML = tree.target
      const data = {
        url: window.location.href,
        kind: 'select_channel',
        code: 'abc'
      }
      this.$http.post(this.$settings.url + 'log', data).then(response => {
        if (response.status === 201) {
          if (this.$settings.ua.browser.indexOf('Firefox') === -1 &&
              this.$settings.ua.isMobile === false) {
            newNode.querySelector('a').setAttribute('target', '_blank')
          }
          const url = newNode.querySelector(
            'a').getAttribute('href').replace(':ref:', ref)
          newNode.querySelector('a').setAttribute('href', url)
          newNode.querySelector('a').click()
        }
      })
    },
    _handleChayall (tree, ref) {
      if (document.querySelector('.chawgt-main-button')) {
        document.querySelector('.chawgt-main-button').click()
      } else {
        const that = this
        window.setTimeout(() => {
          that._handleChayall(tree, ref)
        }, 250)
      }
    },
    _handleGbm (tree, ref) {
      const newNode = document.createElement('div')
      newNode.setAttribute('class', 'wrapper')
      newNode.innerHTML = tree.target
      const data = {
        url: window.location.href,
        kind: 'select_channel',
        code: 'gbm'
      }
      this.$http.post(this.$settings.url + 'log', data).then(response => {
        if (response.status === 201) {
          if (this.$settings.ua.browser.indexOf('Firefox') === -1 &&
              this.$settings.ua.isMobile === false) {
            newNode.querySelector('a').setAttribute('target', '_blank')
          }
          const url = newNode.querySelector(
            'a').getAttribute('href').replace(':ref:', ref)
          newNode.querySelector('a').setAttribute('href', url)
          newNode.querySelector('a').click()
        }
      })
    },
    _handleInstagram (tree, ref) {
      const newNode = document.createElement('div')
      newNode.setAttribute('class', 'wrapper')
      newNode.innerHTML = tree.target
      const data = {
        url: window.location.href,
        kind: 'select_channel',
        code: 'instagram'
      }
      this.$http.post(this.$settings.url + 'log', data).then(response => {
        if (response.status === 201) {
          if (this.$settings.ua.browser.indexOf('Firefox') === -1 &&
              this.$settings.ua.isMobile === false) {
            newNode.querySelector('a').setAttribute('target', '_blank')
          }
          const url = newNode.querySelector(
            'a').getAttribute('href').replace(':ref:', ref)
          newNode.querySelector('a').setAttribute('href', url)
          newNode.querySelector('a').click()
        }
      })
    },
    _handleMessenger (tree, ref) {
      const newNode = document.createElement('div')
      newNode.setAttribute('class', 'wrapper')
      newNode.innerHTML = tree.target
      const data = {
        url: window.location.href,
        kind: 'select_channel',
        code: 'messenger'
      }
      this.$http.post(this.$settings.url + 'log', data).then(response => {
        if (response.status === 201) {
          if (this.$settings.ua.browser.indexOf('Firefox') === -1 &&
              this.$settings.ua.isMobile === false) {
            newNode.querySelector('a').setAttribute('target', '_blank')
          }
          const url = newNode.querySelector(
            'a').getAttribute('href').replace(':ref:', ref)
          newNode.querySelector('a').setAttribute('href', url)
          newNode.querySelector('a').click()
        }
      })
    },
    _handleUrl (tree, $event) {
      const data = {
        url: window.location.href,
        kind: 'click_node'
      }
      this.$http.post(this.$settings.url + 'log', data).then(response => {
        if (response.status === 201) {
          const newNode = document.createElement('a')
          const browserName = this.$settings.ua.browser.toLowerCase()
          if (['mobile safari', 'firefox', 'chrome'].includes(browserName) === false) {
            newNode.setAttribute('target', '_blank')
          }
          newNode.setAttribute('href', tree.target)
          newNode.click()
        }
      })
    },
    _handleWhatsApp (tree, event) {
      const newNode = document.createElement('div')
      newNode.setAttribute('class', 'wrapper')
      newNode.innerHTML = tree.target
      const data = {
        url: window.location.href,
        kind: 'select_channel',
        code: 'whatsapp'
      }
      this.$http.post(this.$settings.url + 'log', data).then(response => {
        if (response.status === 201) {
          const language = document.querySelector('html').getAttribute('lang')
          let url = newNode.querySelector(
            'a').getAttribute('href')
          const text = newNode.querySelector(
            'a').getAttribute(`data-gb-text-${language}`)
          url = url.replace(':text:', encodeURIComponent(text))
          window.location.href = url
        }
      })
    },
    _handleWebChat (tree, ref) {
      if (this.$botSettings !== undefined) {
        this.$botSettings.keyword = ref
        const step = window.GbBot.$store.getters.step === 'button' ? 'chatbox' : 'button'
        window.GbBot.$store.dispatch({
          type: 'changeStep',
          step: step
        })
        window.GbBot.$store.dispatch({
          type: 'initWebsocket'
        })
      }

      const data = {
        url: window.location.href,
        kind: 'select_channel',
        code: 'webchat'
      }
      this.$store.commit('setState', 'back')
      this.$http.post(this.$settings.url + 'log', data)
    },
    handleClick (tree, $event) {
      const ref = this.getReferrer(tree)
      if (tree.action === 'Widget') {
        if (tree.target.indexOf('bcrw.apple') > -1) {
          this._handleAbc(tree, ref, $event)
        } else if (tree.target.indexOf('businessmessages.google') > -1) {
          this._handleGbm(tree, ref)
        } else if (tree.target.indexOf('instagram') > -1) {
          this._handleInstagram(tree, ref)
        } else if (tree.target.indexOf('m.me') > -1) {
          this._handleMessenger(tree, ref)
        } else if (tree.target.indexOf('whatsapp') > -1) {
          this._handleWhatsApp(tree, ref)
        } else if (tree.target.indexOf('chayall') > -1) {
          this._handleChayall(tree, ref)
        } else {
          this._handleWebChat(tree, ref)
        }
      } else if (tree.action === 'URL') {
        this._handleUrl(tree, $event)
      }
    }
  },
  watch: {
    'caller' (newValue, oldValue) {
      this.$store.commit('updateErrors', {})
      const pattern = '^(([0-9]{10})|(\\s|[0-9]{2}){8}([0-9]{2})|(-|[0-9]{2}){8}([0-9]{2}))$'
      const re = new RegExp(pattern)
      const test = re.test(newValue)
      if (!test) {
        this.$store.commit('updateErrors', {
          caller: ['Votre numéro doit comporter 10 chiffres et commencer par 0']
        })
      }
    }
  }
}
</script>
